import React, { useEffect, useState } from 'react';
import { Grid, TextField, Typography, Button, IconButton, InputAdornment } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { updateIncentiveValue, updateIsValid, updateThresholdErrorMsg } from '../../../stateManagement/actions/incentiveActions';
import { useSelector } from 'react-redux';
import { IncentiveHeader } from '../baseComponents/incentiveHeader/IncentiveHeader';
import './CalculateThreshold.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGreaterThanEqual, faLessThanEqual } from '@fortawesome/free-solid-svg-icons';
import { openPopup } from '../../../stateManagement/actions/popupActions';
import RenderSvg from '../../../components/renderSvg/RenderSvg';

interface RangeItem {
  fromRange: string;
  toRange: string;
  rangeValue: string;
}

const CalculateThreshold = (props: { stateName: string }) => {
  const thresholdRange = useSelector((state: any) => state?.manageIncentive?.data[props.stateName]);

  const [rangeArr, setRangeArr] = useState<RangeItem[]>(thresholdRange.value || [
    { fromRange: "", toRange: "", rangeValue: "" }
  ]);
  const [errorMsg, setErrorMsg] = useState(""); // Error message state
  const [disableAddMore , setDisableAddMore] = useState(true);

  useEffect(() => {
    if (thresholdRange.value && thresholdRange.value.length > 0) {
      setRangeArr(thresholdRange.value);
    }
  }, []);

  useEffect(() => {
    let errorMessage = "";
    if (rangeArr.length) {
      let isValid = true;

      for (let index = 0; index < rangeArr.length; index++) {
        const range = rangeArr[index];

        if (!(range.fromRange && range.rangeValue && range.toRange)) {
          isValid = false;
          // errorMessage = "Please fill all the required fields";
          updateThresholdErrorMsg("Please fill and save all the required fields Correctly");
          break;
        }
        if (parseFloat(range.fromRange) >= parseFloat(range.toRange)) {
          isValid = false; // Ensure `toRange` is greater than `fromRange`
          errorMessage = "To range should be greater than From range";
          updateThresholdErrorMsg("To range should be greater than From range");
          break;
        }
        if (!isValidRange(range.fromRange, range.toRange, index)) {
          isValid = false; // Check for overlaps or sub-ranges
          errorMessage = "Range values are overlapping";
          updateThresholdErrorMsg( "Range values are overlapping");
          break;
        }
      }
      setErrorMsg(errorMessage); 
      updateIsValid(isValid, props.stateName);
      if(isValid){
        setDisableAddMore(false);
      }
      else{
        setDisableAddMore(true);
      } // Update validity status
    }
  }, [rangeArr]);

  // Handle input change
  const handleInputChange = (index: number, key: keyof RangeItem, value: string) => {
    let newValue = value;
    
    if (key === 'fromRange' || key === 'toRange') {
      // Validate for 0, numbers between 1-99, and 100 (without leading zeros)
      let regex = /^(100|[1-9][0-9]?|0)$/;
      if (parseInt(value) > 100) {
        // Show a popup and prevent further typing
        openPopup("Alert", "You can not enter percentage greater than 100");
        return;  // Prevent updating the state
      }
      newValue = regex.test(value) || value === "" ? value : "";
    }

    if (key === 'rangeValue') {
      // Validate only for non-leading zeros, but no upper limit
      const regex = /^[1-9][0-9]*$/;
      newValue = regex.test(value) || value === "" ? value : "";
    }

    const updatedArr = rangeArr.map((item, i) =>
      i === index ? { ...item, [key]: newValue } : item
    );
    setRangeArr(updatedArr);
    updateIncentiveValue(updatedArr, props.stateName);
  };
  // Validate that the current item is filled
  const isCurrentItemFilled = (item: RangeItem) => {
    return item.fromRange && item.toRange && item.rangeValue;
  };

  const isToRangeGreater = (item: RangeItem) => {
    if (parseFloat(item.fromRange) >= parseFloat(item.toRange)) {
      return false;
    }
    return true;
  }

  // Validate that ranges are non-overlapping
  const isValidRange = (from: string, to: string, index: number) => {
    const fromNum = parseFloat(from);
    const toNum = parseFloat(to);

    if (isNaN(fromNum) || isNaN(toNum)) return false; // Ensure valid numbers

    // Check overlap and sub-range
    for (let i = 0; i < rangeArr.length; i++) {
      if (i !== index) {
        const rangeFrom = parseFloat(rangeArr[i].fromRange);
        const rangeTo = parseFloat(rangeArr[i].toRange);

        if (
          (fromNum >= rangeFrom && fromNum <= rangeTo) || // From value overlaps
          (toNum >= rangeFrom && toNum <= rangeTo) || // To value overlaps
          (fromNum < rangeFrom && toNum > rangeTo) // Sub-range
        ) {
          return false;
        }
      }
    }
    return true;
  };

  // Add a new range item
  const addNewRangeItem = () => {
    let valid = true;
    for (let index = 0; index < rangeArr.length; index++) {
      const range = rangeArr[index];
      if (!(range.fromRange && range.rangeValue && range.toRange)) {
        openPopup("Alert", "Please fill all the required fields")
        setDisableAddMore(true);
        valid = false;
        break;
      }
      else if (parseFloat(range.fromRange) >= parseFloat(range.toRange)) {
        openPopup("Alert", "To range should be greater than From range");
        setDisableAddMore(true);
        valid = false;
        break;
      }
      else if (!isValidRange(range.fromRange, range.toRange, index)) {
        openPopup("Alert", "Range values are overlapping");
        setDisableAddMore(true);
        valid = false;
        break;
      }
    }
   
    if (rangeArr.length < 5 && valid) { 
      if (isCurrentItemFilled(rangeArr[rangeArr.length - 1])) {
        setRangeArr([...rangeArr, { fromRange: "", toRange: "", rangeValue: "" }]);
      }
      setDisableAddMore(true);
    }
    else{
      openPopup("Alert" , "You can only enter upto 5 slabs")
    }
    
  };

  // Delete a range item
  const deleteRangeItem = (index: number) => {
    if (rangeArr.length > 1) {
      const updatedArr = rangeArr.filter((_, i) => i !== index);
      setRangeArr(updatedArr);
      updateIncentiveValue(updatedArr, props.stateName);
    }
  };

  // const disableAddMore = () => {
  //   if (!isCurrentItemFilled(rangeArr[rangeArr.length - 1]) || !isToRangeGreater(rangeArr[rangeArr.length - 1]) || !isValidRange(rangeArr[rangeArr.length - 1].fromRange, rangeArr[rangeArr.length - 1].toRange, rangeArr.length - 1) || rangeArr.length == 5) {
  //     return true;
  //   }
  //   return false
  // }

  return (
    <IncentiveHeader heading={thresholdRange?.label} open={true}>
      <div style={{ padding: '20px' }}>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>

        <Typography variant="subtitle1" style={{ fontWeight: 200, marginRight: '15px', color: "grey" , fontSize : "12px" , marginTop : "8px"}}><u>Add Upto 5 Slabs</u></Typography>
          <Button
            variant="outlined"
            style={{
              borderColor:  !disableAddMore ? '#43B442'
              : 'grey', color: !disableAddMore ? '#43B442'
                : 'grey', backgroundColor: disableAddMore ? 'white' : "#ecf7ec",
              gap:"7px"
            }}
            onClick={addNewRangeItem}
            //disabled={disableAddMore}
          >
            <RenderSvg name="add_threshold"/>
            Add More
          </Button>
        </div>

        <div style={{ width: "100%", marginTop: "20px" }}>
          {rangeArr.map((range, index) => (
            <div key={index} className='threshold-box'>
              <div className="range-value-row">
                {/* Define Range Section */}
                <Typography variant="subtitle1" style={{ fontWeight: 500, marginRight: '15px', flex: '0 0 120px', color: "grey" }}>Define Range<span style={{color: 'rgb(255, 87, 51)'}}>*</span></Typography>
                <TextField
                  type="number"
                  InputProps={{ inputProps: { min: 0, max: 100 }, endAdornment: <InputAdornment position="end">%</InputAdornment>, startAdornment: <InputAdornment position="start"><FontAwesomeIcon icon={faGreaterThanEqual} size='sm' /></InputAdornment> }}
                  label="From"
                  variant="outlined"
                  size="small"
                  value={range.fromRange}
                  onKeyDown={(e) => {
                    if (['-', '+', '.', 'e', 'E'].includes(e.key)) {
                      e.preventDefault(); // Prevent these keys from being entered
                    }}}
                  onChange={(e) => handleInputChange(index, 'fromRange', e.target.value)}
                  // error={range.fromRange ? disableAddMore() : false}
                  style={{ marginRight: "10px" , backgroundColor : isCurrentItemFilled( rangeArr[rangeArr.length - 1]) ? '#F0FBFF' : '' , color : isCurrentItemFilled( rangeArr[rangeArr.length - 1]) ? '#F0FBFF' : 'black' }}
                />
                <TextField
                  type="number"
                  label="To"
                  InputProps={{ inputProps: { min: 0, max: 100 }, startAdornment: <InputAdornment position="start"><FontAwesomeIcon icon={faLessThanEqual} size='sm' /></InputAdornment>, endAdornment: <InputAdornment position="end">%</InputAdornment> }}
                  variant="outlined"
                  size="small"
                  value={range.toRange}
                  onKeyDown={(e) => {
                    if (['-', '+', '.', 'e', 'E'].includes(e.key)) {
                      e.preventDefault(); // Prevent these keys from being entered
                    }}}
                  onChange={(e) => handleInputChange(index, 'toRange', e.target.value)}
                  // error={range.fromRange ? disableAddMore() : false}
                  style={{ marginRight: "20px" ,  backgroundColor : isCurrentItemFilled( rangeArr[rangeArr.length - 1]) ? '#F0FBFF' : '' , color : isCurrentItemFilled( rangeArr[rangeArr.length - 1]) ? '#F0FBFF' : 'black' }}
                />

                {/* Define Value Section */}
                <Typography variant="subtitle1" style={{ fontWeight: 500, marginRight: '15px', flex: '0 0 120px', color: "grey" }}>Define Value<span style={{color: 'rgb(255, 87, 51)'}}>*</span></Typography>
                <TextField
                  type="number"
                  label="Value"
                  variant="outlined"
                  size="small"
                  style={{ marginRight: '10px', flex: 1, backgroundColor : isCurrentItemFilled( rangeArr[rangeArr.length - 1]) ? '#F0FBFF' : '' , color : isCurrentItemFilled( rangeArr[rangeArr.length - 1]) ? '#F0FBFF' : 'black' }}
                  InputProps={{
                    inputProps: { min: 1 },
                    startAdornment: <InputAdornment position="start">$</InputAdornment>
                  }}
                  onKeyDown={(e) => {
                    if (['-', '+', '.', 'e', 'E'].includes(e.key)) {
                      e.preventDefault(); // Prevent these keys from being entered
                    }}}
                  value={range.rangeValue}
                  onChange={(e) => handleInputChange(index, 'rangeValue', e.target.value)}
                />

                {/* Delete Button */}
                {rangeArr.length == 1  ? <div  style={{ marginLeft: '10px' , height : "30px" ,  width: '46px',}}></div> :<IconButton onClick={() => deleteRangeItem(index)} aria-label="delete" style={{ marginLeft: '10px' }}>
                  <DeleteIcon color='error' />
                </IconButton>  }
              </div>
            </div>
          ))}
          <div style={{position : "relative" , bottom : "25px" , left : "150px" , fontSize : "12px" , color : "red"}}><span>{errorMsg}</span></div>
        </div>
        
      </div>
    </IncentiveHeader>
  );


};

export default CalculateThreshold;
